<template>
  <StatusBadge :data="statusData" />
</template>

<script>
import StatusBadge from '@components/StatusBadge.vue'

export default {
  name: 'TimeOffSettingStatus',
  components: { StatusBadge },
  props: {
    timeSetting: Object
  },
  computed: {
    statusData () {
      return {
        class: this.timeSetting.is_deactivated ? 'inactive' : 'approved',
        label: this.timeSetting.is_deactivated ? 'Inactive' : 'Active'
      }
    }
  }
}
</script>
